import { PaymentType } from '@afterpay/types'
import { Heading, Link } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent, useEffect } from 'react'
import { Route } from '../../config/router'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { CheckoutStatus } from '../../model'
import {
  selectPurchaseMethod,
  setCheckoutStatus,
  setSelectedPaymentType,
  useAppDispatch,
  useAppropriatePaymentMethod,
  useAppRouter,
  usePBIRejected,
} from '../../state'
import { useCheckoutSizes } from '../../utils/responsive'
import styles from './style.module.css'

interface PayInFourCtaProps {
  trackingEvent?: string
}

export const PayInFourCta: FunctionComponent<PayInFourCtaProps> = ({ trackingEvent }) => {
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()
  const router = useAppRouter()
  const dispatch = useAppDispatch()
  const paymentMethod = useAppropriatePaymentMethod()
  const testNameSpace = 'pay-in-4'
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const hasPBIRejected = usePBIRejected()

  useEffect(() => {
    router.prefetch(Route.SUMMARY)
  }, [])

  const handlePBIClick = (): void => {
    dispatch(setSelectedPaymentType(PaymentType.PBI))
    if (trackingEvent) {
      logEvent(trackingEvent)
    }
    if (paymentMethod !== null) {
      dispatch(selectPurchaseMethod(paymentMethod))
    } else {
      dispatch(setCheckoutStatus(CheckoutStatus.LackOfEligiblePaymentMethod))
    }
    router.push(Route.SUMMARY)
  }

  return !hasPBIRejected ? (
    <div className={styles.PayInFourCta}>
      <Link onClick={handlePBIClick} testNameSpace={testNameSpace} kind='Underline'>
        <Heading size={textSize} testNameSpace={testNameSpace}>
          {t('consumerLending:approvedCredit:payIn4')}
        </Heading>
      </Link>
    </div>
  ) : (
    <></>
  )
}
